import { useCurrentUser } from 'services/repositories/user/user';
import { Page } from 'components/Page/Page';

export function Metabase() {
  const { data: currentUser } = useCurrentUser();

  function renderIframe() {
    if (!currentUser?.partner?.metabase_dashboard_url) {
      return <div>No metabase dashboard url found</div>;
    }

    return <iframe src={currentUser?.partner?.metabase_dashboard_url} style={{ width: '100%', height: '100vh' }} />;
  }

  return (
    <Page>
      <div className="flex flex-col items-center justify-center">{renderIframe()}</div>
    </Page>
  );
}
